import { API_CONSUMER } from './api'
import {
  API_INTEGRATION_URL,
  API_KEY,
  API_REQUEST_ORIGIN,
  API_URA_KEY,
  API_URA_TOKEN,
  API_URA_URL,
  API_URL,
} from './envs'

export const OPTIONS = {
  baseURL: API_URL,
  headers: {
    apikey: API_KEY,
    'x-origin': API_REQUEST_ORIGIN,
  },
}

export const OPTIONS_INTEGRATION = {
  baseURL: API_INTEGRATION_URL,
  headers: {
    apikey: API_KEY,
    'x-origin': API_REQUEST_ORIGIN,
    consumer: API_CONSUMER,
  },
}

export const PUBLIC_OPTIONS_INTEGRATION = {
  ...OPTIONS_INTEGRATION,
  public: true,
}

export const OPTIONS_URA = {
  baseURL: API_URA_URL,
  headers: {
    token: API_URA_TOKEN,
    apikey: API_URA_KEY,
  },
  public: true,
}
